import { Maybe, ENUM_COMPONENTSHAREDCTA_KIND } from './globalTypes'

import slideTypeRawString from '../../fragments/SlideType.graphql'

export const slideTypeString = slideTypeRawString

export type SlideType = {
  __typename: 'ComponentSharedSlide'
  id: string
  title: string
  description: string
  themeBgColor: Maybe<string>
  image: {
    url: string
  }
  button: Maybe<{
    textColorOverride: Maybe<string>
    backgroundColorOverride: Maybe<string>
    label: string
    kind: ENUM_COMPONENTSHAREDCTA_KIND
    url: Maybe<string>
    action: Maybe<string>
    route: Maybe<string>
  }>
}

export const isSlideType = (fragment: any): fragment is SlideType =>
  fragment &&
  fragment.__typename === 'ComponentSharedSlide' &&
  typeof fragment.id === 'string' &&
  typeof fragment.title === 'string' &&
  typeof fragment.description === 'string' &&
  (fragment.themeBgColor === null ||
    typeof fragment.themeBgColor === 'string') &&
  fragment.image &&
  typeof fragment.image.url === 'string' &&
  (fragment.button === null ||
    (fragment.button &&
      (fragment.button.textColorOverride === null ||
        typeof fragment.button.textColorOverride === 'string') &&
      (fragment.button.backgroundColorOverride === null ||
        typeof fragment.button.backgroundColorOverride === 'string') &&
      typeof fragment.button.label === 'string' &&
      (fragment.button.kind === 'external_url' ||
        fragment.button.kind === 'internal_url' ||
        fragment.button.kind === 'app_route' ||
        fragment.button.kind === 'app_action') &&
      (fragment.button.url === null ||
        typeof fragment.button.url === 'string') &&
      (fragment.button.action === null ||
        typeof fragment.button.action === 'string') &&
      (fragment.button.route === null ||
        typeof fragment.button.route === 'string')))
